import { Box, Grid } from '@mui/material'
import React from 'react'
import SectionTitle from './SectionTitle'
import BenefitSlider from './Sliders/BenefitSlider'

const BenefitSection = ({ benefits }) => {
  const { header_title=[], sliders=[] } = benefits || {}
  return (
    <Box sx={{ p: 7, pb: 14 }}>
      <Grid container sx={{ mb: 4 }}>
        <Grid item xs={12} md={12}>
          <SectionTitle align='center' variant={'h4'} header={header_title} />
        </Grid>
      </Grid>
      <Grid container sx={{ justifyContent: 'center' }}> 
        <Grid item xs={12} md={8}>
            <BenefitSlider benefitList={sliders} />
          </Grid>
      </Grid>
    </Box>
  )
}

export default BenefitSection